import React from "react"
import Grid from "../../../../grid"
import { P } from "../../../../typography"
import { VideoContainer, VideoWrapper, Video } from "../../../../content/styles"

const VideoFrame = ({ label, answer }) => (
  <Grid gap="0.5rem">
    {label && label.length > 0 && (
      <P variant="content" size="medium" marginless bold>
        {label}
      </P>
    )}
    <VideoContainer>
      <VideoWrapper>
        <Video title={label} width="560" height="349" src={answer} frameBorder="0" allowFullScreen />
      </VideoWrapper>
    </VideoContainer>
  </Grid>
)

export default VideoFrame
